class FloatingAddToCart extends HTMLElement {
  constructor() {
    super();
    /** @type {IntersectionObserver} */
    this.observer;
    this.observerOptions = {};
    /** @type {HTMLDivElement} */
    this.elementToHideOn;

    this.observerCallback = this.observerCallback.bind(this);
  }

  connectedCallback() {
    this.elementToHideOn = document.querySelector(".product-form__buttons");
    this._setup();
  }

  _setup() {
    if (!this.elementToHideOn) return;
    this.observer = new IntersectionObserver(this.observerCallback);
    this.observer.observe(this.elementToHideOn);
  }

  /**
   *
   * @param {IntersectionObserverEntry[]} entries
   * @param {*} observer
   */
  observerCallback(entries, observer) {
    if (entries[0].isIntersecting) {
      this.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
    }
  }
}

customElements.define("floating-add-to-cart", FloatingAddToCart);
